export interface LibroDiarioAndMayorCommonProps {
  dateFilter?: Date[]
}

export interface ContabilidadStateProps {
  libroDiarioAndMayorCommon?: LibroDiarioAndMayorCommonProps
}

export const contabilidad: ContabilidadStateProps = {
  libroDiarioAndMayorCommon: {
    dateFilter: [new Date(`${new Date().getFullYear()}-01-01`), new Date()],
  },
}
